import { useParams } from "@tanstack/react-router";

import type { Job, JobQuoteRequest, JobRequest } from "../../../api/generated/model";
import { usePricedStart } from "../../../platform/jobs/priced-start";

// The brand's route, which the Sounds page and the Pro Studio redesign's Create page both sit
// under: the composer reads its team and brand from it wherever it is drawn.
export const ROUTE = "/signed-in/teams/$teamId/brands/$brandId";

/**
 * A sound's price and start: the generation forms' one priced start (`usePricedStart`, G1,
 * G7-sound-types) on the brand's team and brand. Live shows the bolt alone until something
 * is written (`written`, design-ref/sound SPEC.md: "Price on an empty prompt: bolt only in all
 * three modes"), though the quote runs.
 */
export function useSoundJob(
  quote: JobQuoteRequest | undefined,
  request: JobRequest | undefined,
  written: boolean,
  onStarted: (job: Job) => void,
) {
  const { teamId, brandId } = useParams({ from: ROUTE });
  const job = usePricedStart({ teamId, brandId, quote, request, onStarted });
  return {
    ...job,
    priced: written ? job.priced : undefined,
    pricing: written && job.pricing,
  };
}

export type SoundJob = ReturnType<typeof useSoundJob>;
